import {
  setAdvanceModeNegativePrompt,
  statusStore,
  updateNegativePromptSettings,
} from "@/stores/status";
import { genBlock } from "@/utils/bem";
import { Editor_Words } from "@/utils/lang/editor";
import { chakra } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import React from "react";
import { WordTable } from "../WordTable";
import "./style.scss";

const block = genBlock("c-negative-prompt-word-table");
const INegativePromptWordTable: React.FC = () => {
  const lang = langStore.tgt;
  return (
    <WordTable
      className={block("container")}
      text={statusStore.advanceModeNegativePrompt}
      setText={setAdvanceModeNegativePrompt}
      title={translate(Editor_Words["negative-prompt-word-table-title"], lang)}
      onSelect={(record) => {
        updateNegativePromptSettings(record);
      }}
      tablePopupProps={{
        maxW: {
          base: "500px",
          lg: "500px",
          md: "500px",
        },
        minW: "500px",
        className: block(),
      }}
      sourceUrl="https://localimage.oss-cn-hangzhou.aliyuncs.com/noli_creator_static/json/negative_keywords.json"
      searchPlaceholder={Editor_Words["negative-prompt-keyword-search-placeholder"]}
      tableTitle={Editor_Words["negative-prompt-keyword-list-title"]}
      tableName="negativePromptKeywords"
    />
  );
};

export const NegativePromptWordTable = chakra(observer(INegativePromptWordTable));
